(() => {
  const SELECTOR = '[data-season-archive]';

  function initSeasonArchive(section) {
    if (!section || section.dataset.swiperInitialized === 'true') {
      return;
    }

    const slider = section.querySelector('[data-season-archive-swiper]');
    const previousButton = section.querySelector(
      '[data-season-archive-prev]'
    );
    const nextButton = section.querySelector(
      '[data-season-archive-next]'
    );

    if (!slider || typeof window.Swiper === 'undefined') {
      return;
    }

    const swiper = new window.Swiper(slider, {
      slidesPerView: 1.45,
      spaceBetween: 16,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      breakpoints: {
        480: {
          slidesPerView: 2.15,
          spaceBetween: 18,
        },
        750: {
          slidesPerView: 3.2,
          spaceBetween: 22,
        },
        990: {
          slidesPerView: 4.25,
          spaceBetween: 26,
        },
        1280: {
          slidesPerView: 5.2,
          spaceBetween: 30,
        },
      },
    });

    section.seasonArchiveSwiper = swiper;
    section.dataset.swiperInitialized = 'true';
  }

  function initAllSeasonArchives(container = document) {
    container.querySelectorAll(SELECTOR).forEach(initSeasonArchive);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAllSeasonArchives();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches(SELECTOR)
      ? event.target
      : event.target.querySelector(SELECTOR);

    if (section) {
      initSeasonArchive(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches(SELECTOR)
      ? event.target
      : event.target.querySelector(SELECTOR);

    if (!section?.seasonArchiveSwiper) {
      return;
    }

    section.seasonArchiveSwiper.destroy(true, true);

    delete section.seasonArchiveSwiper;
    delete section.dataset.swiperInitialized;
  });
})();